import React, { useState, useEffect, useContext } from 'react'
import Proptypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import {
  Button,
  Modal,
  Form,
  FormField,
  Segment,
  Dropdown,
  Icon,
  Header,
} from 'semantic-ui-react'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import Swal from 'sweetalert2'
import { primaryColor } from '../../../../constants'
import { CustomerViewContext } from '../customer-info-view/customerView'
import { GetUserCustomers } from '../../../../services/asset/index'
import { setCustomerData } from '../../../../redux/actions/facility'
// import { FacilityViewContext } from '../../../facility/facility-info-view/facilityView'
import { addHierarchy } from '../../../../services/customer'

let tenantId = ''
let product = ''
const specialChar = /^[A-Za-z0-9ء-ي ]+$/

const formValidator = {
  name: yup
    .string()
    .trim()
    .required('Name Is Required')
    .matches(specialChar, 'Name has invalid characters'),
  Latitude: yup.string().trim().required('Latitude Is Required'),

  Longitude: yup.string().trim().required('Longitude Is Required'),
}
const tankFormValidator = {
  name: yup
    .string()
    .trim()
    .required('Name Is Required')
    .matches(specialChar, 'Name has invalid characters'),
}
const AddZoneModal = (props) => {
  const dispatch = useDispatch()
  const [customersList, setCustomersList] = useState([])
  const [selectedCustomer, setSelectedCustomer] = useState()

  const { userEmail } = useSelector((store) => ({
    userEmail: store.auth.userEmail,
  }))

  if (userEmail) {
    const products = JSON.parse(localStorage.getItem('products'))
    product = localStorage.getItem('product')
    console.log('product', product)
    // eslint-disable-next-line prefer-destructuring
    tenantId = products.filter((p) => p.productName === product)[0]
  }
  console.log('tenantId', tenantId)
  const [open, setOpen] = useState(false)
  const { customerSettings } = useContext(CustomerViewContext)
  console.log('customerSettings', customerSettings)
  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(
      yup
        .object()
        .shape(product === 'cold' ? formValidator : tankFormValidator),
    ),
  })
  useEffect(() => {
    if (product === 'cold') {
      const customerData = []
      GetUserCustomers(userEmail, product).then((customers) => {
        console.log('customers', customers)
        customers.forEach((customer) => {
          customerData.push({
            text: customer.title,
            value: customer.tbCustomerId,
          })
        })
        setCustomersList(customerData)
      })
    }
  }, [])

  useEffect(() => {
    setOpen(props.open)
  }, [props.open])

  useEffect(() => {
    props.getOpenState('zone', open)
  }, [open])

  const addZone = async (data) => {
    if (data.name.trim() === '') return
    let body = {}
    console.log('data', data)
    if (product === 'cold') {
      body = {
        name: data.name,
        type: product === 'cold' ? 'country' : 'zone',
        tenantId: tenantId.tenantId,
        searchText: data.name,
        customerId: selectedCustomer,
        latitude: data.Latitude,
        longitude: data.Longitude,
      }
    }
    if (product !== 'cold') {
      body = {
        name: `${customerSettings.title}_${data.name}`,
        type: 'zone',
        label: data.name,
        tenantId: tenantId.tenantId,
        searchText: data.name,
        customerId: customerSettings.tbCustomerId,
      }
    }

    const queryParams = {
      product,
      fromId:
        product === 'cold' ? selectedCustomer : customerSettings.tbCustomerId,
      fromType: 'CUSTOMER',
    }
    if (product === 'cold') {
      queryParams.lat = data.Latitude
      queryParams.lng = data.Longitude
    }
    console.log(body)
    Swal.showLoading()
    const res = await addHierarchy(queryParams, body)
    if (res.success) {
      await Swal.fire({
        title: 'Level 1 Added Successfully',
        icon: 'success',
        confirmButtonColor: 'Green',
      })
      setOpen(false)
      console.log(res)
    } else {
      Swal.fire(res.msg || 'Error adding Level 1', '', 'error')
    }
  }

  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      >
        <Modal.Header>Add Level 1 (Top Level)</Modal.Header>
        <Modal.Content>
          {!selectedCustomer && product === 'cold' ? (
            <Segment placeholder>
              <Header icon>
                <Icon name="address card" />
                Please Select Customer
              </Header>

              <Dropdown
                name="customers"
                options={customersList}
                placeholder="Select Customer to Add New Level"
                defaultValue={selectedCustomer}
                fluid
                search
                selection
                onChange={async (e, data) => {
                  console.log('e.target.value', data.value)
                  setSelectedCustomer(data.value)
                  dispatch(setCustomerData(data.value))
                }}
              ></Dropdown>
            </Segment>
          ) : null}
          {selectedCustomer && product === 'cold' ? (
            <Form
              style={{
                padding: 10,
                borderRadius: 9,
              }}
              onSubmit={handleSubmit(addZone)}
              id="customerSettings"
            >
              <FormField>
                <span>* Level 1 Name:</span>
                <input
                  name="name"
                  ref={register}
                  type="text"
                  placeholder="Name"
                />
                {errors.name && (
                  <p style={{ color: 'red' }}>{errors.name.message}</p>
                )}
              </FormField>
              <Form.Group widths="equal">
                <FormField>
                  <span>* Latitude:</span>
                  <input
                    name="Latitude"
                    ref={register}
                    type="number"
                    placeholder="Latitude"
                    step="any"
                  />
                  {errors.Latitude && (
                    <p style={{ color: 'red' }}>{errors.Latitude.message}</p>
                  )}
                </FormField>
                <FormField>
                  <span>* Longitude:</span>
                  <input
                    name="Longitude"
                    ref={register}
                    type="number"
                    step="any"
                    placeholder="Longitude"
                  />
                  {errors.Longitude && (
                    <p style={{ color: 'red' }}>{errors.Longitude.message}</p>
                  )}
                </FormField>
              </Form.Group>

              <Button
                from="config form"
                type="submit"
                style={{ backgroundColor: primaryColor, color: 'white' }}
              >
                Submit
              </Button>
            </Form>
          ) : null}
          {product !== 'cold' && (
            <Form
              style={{
                padding: 10,
                borderRadius: 9,
              }}
              onSubmit={handleSubmit(addZone)}
              id="customerSettings"
            >
              <FormField>
                <span>* Level 1 Name:</span>
                <input
                  name="name"
                  ref={register}
                  type="text"
                  placeholder="Name"
                />
                {errors.name && (
                  <p style={{ color: 'red' }}>{errors.name.message}</p>
                )}
              </FormField>

              <Button
                from="config form"
                type="submit"
                style={{ backgroundColor: primaryColor, color: 'white' }}
              >
                Submit
              </Button>
            </Form>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="black"
            onClick={() => {
              setSelectedCustomer()
              setOpen(false)
            }}
          >
            Cancel
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  )
}

AddZoneModal.propTypes = {
  open: Proptypes.bool,
  getOpenState: Proptypes.func,
}

export default AddZoneModal
